import { render, staticRenderFns } from "./ProjectPlacements.vue?vue&type=template&id=37ebcbe0"
import script from "./ProjectPlacements.vue?vue&type=script&lang=js"
export * from "./ProjectPlacements.vue?vue&type=script&lang=js"
import style0 from "./ProjectPlacements.vue?vue&type=style&index=0&id=37ebcbe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports